import { useAuthStore } from "./store";
import { roleAtLeast, type Role } from "@/shared/api/schemas/common";

export function useSession() {
  const staff = useAuthStore((s) => s.staff);
  const status = useAuthStore((s) => s.status);
  return { staff, status, isAuthenticated: status === "authenticated" && staff !== null };
}

export function useHasRole(minimum: Role): boolean {
  const staff = useAuthStore((s) => s.staff);
  return staff !== null && roleAtLeast(staff.role, minimum);
}
